export default "__VITE_ASSET__f26f522f__"